import React from "react";

interface RichTextProps {
    children: string;
    className?: string;
    style?: React.CSSProperties;
}

export function RichText({ children, className, style }: RichTextProps) {
    return (
        <div
            className={className}
            style={style}
            dangerouslySetInnerHTML={{ __html: children }}
        />
    );
}
